/**
 * Centralized z-index scale for consistent stacking context management.
 *
 * Use these constants instead of inline z-index values to maintain
 * a predictable stacking order across the application.
 */
export const zIndex = {
  /** Dropdowns, popovers, and basic overlays */
  dropdown: 1000,
  /** Sticky bars and elements that sit above dropdowns */
  stickyBar: 1100,
  /** Cookie consent banner, above sticky bars so consent buttons stay tappable */
  cookieConsent: 1200,
  /** Primary navigation overlays */
  navigation: 8000,
  /** Modal overlay/backdrop layer */
  modalOverlay: 9998,
  /** Standard modals and dialogs */
  modal: 9999,
  /** Full-screen modals (reviews, search) */
  fullScreenModal: 10000,
  /** Tooltips — always on top of modals */
  tooltip: 10001,
  /** Maximum z-index for exceptional cases (e.g., drawers) */
  max: 99999,
} as const;
